import React, {useEffect, useRef, useState} from 'react';
import {motion, useInView} from 'framer-motion';

import Button from '../common/Button';
import ExampleCard from './ExampleCard';

import {useMediaQuery} from '../../hooks/useMediaQuery';
import {useMovePage} from '../../hooks/useMovePage';
import styles from './styles/main-07.module.css';

import {ReactComponent as FeedbackImg} from '../../assets/main07/feedback.svg';
import {ReactComponent as DashboardImg} from '../../assets/main07/dashboard.svg';

const easeInMotion = {
    ease: 'easeIn',
    duration: 0.8
};

export default function Main07() {
    const mobileSmall = useMediaQuery('(max-width: 480px)');
    const mobileMedium = useMediaQuery('(min-width: 481px) and (max-width: 768px)');

    const movePage = useMovePage();

    const ref = useRef(null);
    
    const isInView = useInView(ref, {
        once: true,
        amount: mobileSmall || mobileMedium ? 0.1 : 0.2,
        margin: mobileMedium ? '-10px 0px' : '-100px 0px'
    });

    const [step, setStep] = useState(0);

    useEffect(() => {
        if (isInView) {
            const timer1 = setTimeout(() => setStep(1), 0); // 제목
            const timer2 = setTimeout(() => setStep(2), 400); // 첫 번째 카드
            const timer3 = setTimeout(() => setStep(3), 1200); // 두 번째 카드
    
            return () => {
                [timer1, timer2, timer3].forEach(clearTimeout);
            };
        }
    }, [isInView]);    

    return (
    <div className={styles.wrapper}>
        <div className={styles.container} ref={ref}>
            <motion.p
                initial={{ opacity: 0 }}
                animate={isInView ? { opacity: 1 } : { opacity: 0 }}
                transition={easeInMotion}
            >
                사용할수록 더 똑똑해져요!
            </motion.p>
            <div className={styles.boxCard}>
                <ExampleCard 
                    type='feedback'
                    example='관리자 페이지 : 피드백 관리'
                    title='피드백을 반영해 AI를 발전시키세요'
                    subTitle='피드백을 모니터링하며 빠르게 AI 성능을 개선하세요'
                    Image={FeedbackImg}
                    isVisible={step >= 2}
                />
                <ExampleCard 
                    type='dashboard'
                    example='관리자 페이지 : 대시보드'
                    title='질문 흐름, 한눈에 확인하세요'
                    subTitle='질문 패턴과 사용량을 쉽게 모니터링할 수 있어요'
                    Image={DashboardImg}
                    isVisible={step >= 3}
                />
            </div>
            <Button
                text='DARVIS는 이렇게 관리돼요 →'
                width={mobileSmall ? '218px': '320px'}
                height={mobileSmall ? '38px': '58px'}
                padding='8px 12px'
                backgroundColor='#825DFC'
                border='none'
                borderRadius={mobileSmall ? '10px': '15px'}
                fontSize={mobileSmall ? '16px': '24px'}
                fontWeight={mobileSmall ? '600': '700'}
                textColor='#FFF'
                onClick={() => movePage('/service/admin')}
            />
        </div>
    </div>
  );
}
